import { useState, useEffect } from 'react';
import { Button, IconButton, Tooltip, TableCell } from '@material-ui/core';
import ShowChart from '@material-ui/icons/ShowChart';

import ChartPopup from 'app/admin/common/component/ChartPopup';
import MeasurementTableService from 'app/admin/measurement/service/MeasurementTableService';

function ShowChartButton(props) {
    const [openDialog, setOpenDialog] = useState(false);

    const [data, setData] = useState(null);

    useEffect(() => {
        if (!data && openDialog && props.item.id) MeasurementTableService.getData(props.item.id, null, null).then(_data => { setData(_data ?? null); });
    }, [props.item, openDialog]);

    return (
        <>

            {props.form ? <Button className='whitespace-nowrap mx-4' variant='contained' color='secondary' disabled={!props.item || !props.item.id} onClick={e => { setOpenDialog(true); e.preventDefault(); }} startIcon={<ShowChart className='hidden sm:flex' />}>
                Show Chart
            </Button> : <TableCell className='w-auto text-center' padding='none'>
                <Tooltip title='Show Chart'>
                    <IconButton onClick={e => { setOpenDialog(true); e.preventDefault(); }}><ShowChart fontSize='small' /></IconButton>
                </Tooltip>
            </TableCell>}

            {openDialog && (<ChartPopup data={data} onClose={() => setOpenDialog(false)} />)}

        </>
    );
}

export default ShowChartButton;